import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class VendorPaymentPlanService {
    constructor(private http: HttpClient) { }

    getAllPlans() {
        return this.http.get<any>(`${environment.apiUrl}/vendor-payment-plans`);
    }

    getPlan(id): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/vendor-payment-plans/${id}`);
    }

}
